import React, { useState } from 'react';
import "./type.css";

const Type = (props) => {

  const [color, setColor] = useState("#F7F5F2");

  const click = () => {
    setColor(color === "#F7F5F2" ? "#2a2a2a" : "#F7F5F2");
  };

  return ( 
    <div className="type">
      <div onClick={click} style={{ background: color }} className="check"></div>
      <span>{props.text}</span>
    </div>
  );
};

export default Type;